import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import messages from './messages';
import ReusableGridButton from '../../../components/grid-header/reusable-grid-button';
import { launchCustomersCreateLabelModal } from '../../../store/customers/create-label/customers.create-label.actions';
import Global from '../../../store/global-selectors';

export const CreateLabelButton = () => {
  const dispatch = useDispatch();
  const selectedCustomersCount = useSelector(Global.selectSelectedCustomersCount);
  const hasShippingRole = useSelector(Global.selectUserhasShippingRole);

  const isDisabled = selectedCustomersCount !== 1 || !hasShippingRole;

  const actionHandler = useCallback(() => {
    dispatch(launchCustomersCreateLabelModal());
  }, [dispatch]);

  return (
    <ReusableGridButton actionHandler={actionHandler} disable={isDisabled} messageDescriptor={messages.createLabel} theme='tertiary' />
  );
};
